import { Option, FilterItemBaseInterface } from "@/modules/Settings/interfaces";

/**
 * Converte uma lista de itens do tipo `FilterItemBaseInterface`
 * para o formato esperado por componentes de seleção (key/text).
 *
 * @param {Array<FilterItemBaseInterface>} items - Lista de itens contendo `id` e `name`.
 * @returns {{ key: number , text: string }[]} Lista transformada contendo `key` e `text`.
 *
 * @example
 * const input = [
 *   { id: 1, name: "Opção A" },
 *   { id: 2, name: "Opção B" }
 * ];
 *
 * Resultado:
 * [
 *   { key: 1, text: "Opção A" },
 *   { key: 2, text: "Opção B" }
 * ]
 */
export const formatToSelect = (
  items?: Array<FilterItemBaseInterface>
): Array<Option> => {
  const formattedItems = items?.map(item => {
    return { key: item.id, text: item.name };
  });

  return formattedItems || [];
};
